import { render, staticRenderFns } from "./departmentDisasePages.vue?vue&type=template&id=6bb2d23a&scoped=true&"
import script from "./departmentDisasePages.vue?vue&type=script&lang=js&"
export * from "./departmentDisasePages.vue?vue&type=script&lang=js&"
import style0 from "./departmentDisasePages.vue?vue&type=style&index=0&id=6bb2d23a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb2d23a",
  null
  
)

export default component.exports